import { ContactUsBannerWrapper } from "../../styles/StyledComponents/ContactUsBannerWrapper";
import assests from "../../ui/assests";
import CommonButton from "../../ui/CommonButton/CommonButton";
import SendIcon from "../../ui/icons/SendIcon";
import InputWrap from "../../ui/InputWrap/InputWrap";
import { EnquiryMock } from "../../ui/json/demo.mock";

const ContactUsBanner = () => {
  const handelfromSubmit = (e: any) => {
    e.preventDefault();

    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    const payload = Object.fromEntries(formData.entries());

    console.log("Form submitted:", payload);
  };

  return (
    <ContactUsBannerWrapper>
      <div className="contact_inner_Data">
        <figure className="contact_bg_img">
          <img src={assests.contactBG} alt="contactBG" />
        </figure>
        <div className="container">
          <div className="row contact_row">
            <div className="cmn_contact_col col_left ">
              <div className="col_left_inner">
                <h1>Connect with Our Expert Team for Enquiry</h1>
                <h3 className="contact_sub_heading">
                  Experience the Power of Collaboration
                </h3>
                <p className="descriptionText">
                  At Weavers Web, we value your time and ideas. That’s why we’ve
                  streamlined our process to ensure a seamless and efficient
                  experience for you
                </p>
                <ul className="listBox">
                  {EnquiryMock?.map((data, index) => (
                    <li key={index}>
                      <span>{data?.listTitle}</span>:&nbsp;{data?.listDetails}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="cmn_contact_col col_righ">
              <div className="right_inner_from">
                <form className="row from_Row" onSubmit={handelfromSubmit}>
                  <div className="col_6 from_Col">
                    <InputWrap
                      id="firstName"
                      name="firstName"
                      placeholder="First Name"
                    />
                  </div>
                  <div className="col_6 from_Col">
                    <InputWrap
                      id="lastName"
                      name="lastName"
                      placeholder="Last Name"
                    />
                  </div>
                  <div className="col_6 from_Col">
                    <InputWrap
                      id="mobile"
                      name="mobile"
                      placeholder="Mobile No."
                    />
                  </div>
                  <div className="col_6 from_Col">
                    <InputWrap
                      id="country"
                      name="country"
                      placeholder="Country"
                    />
                  </div>
                  <div className="col_12 from_Col">
                    <InputWrap
                      id="email"
                      name="email"
                      placeholder="Email Address"
                    />
                  </div>
                  <div className="col_12 from_Col">
                    <InputWrap
                      id="service"
                      name="service"
                      labelText="What service are you looking for?"
                    />
                  </div>
                  <div className="col_12 from_Col">
                    <InputWrap
                      id="industry"
                      name="industry"
                      labelText="Specify your target industry"
                    />
                  </div>
                  <div className="col_12 from_Col">
                    <InputWrap
                      id="requirement"
                      name="requirement"
                      multiline
                      placeholder="Describe your requirement in brief"
                      rows={3}
                    />
                  </div>
                  <div className="col_12 from_Col">
                    <CommonButton
                      variant="contained"
                      fullWidth
                      type="submit"
                      color="primary"
                      endIcon={<SendIcon />}
                    >
                      Submit
                    </CommonButton>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContactUsBannerWrapper>
  );
};

export default ContactUsBanner;
